export default __webpack_public_path__ + "static/media/uaw-sign.bc869638.png";